/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationCreate } from '../models/NotificationCreate';
import type { NotificationOut } from '../models/NotificationOut';
import type { NotificationUpdate } from '../models/NotificationUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationTemplatesService {
    /**
     * List Notifications
     * @param skip
     * @param limit
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static listNotificationsServiceRequestsNotificationTemplatesGet(
        skip?: number,
        limit: number = 100,
    ): CancelablePromise<Array<NotificationOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service_requests/notification/templates/',
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Notification
     * @param requestBody
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static createNotificationServiceRequestsNotificationTemplatesPost(
        requestBody: NotificationCreate,
    ): CancelablePromise<NotificationOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/service_requests/notification/templates/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Notification
     * @param notificationId
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static getNotificationServiceRequestsNotificationTemplatesNotificationIdGet(
        notificationId: number,
    ): CancelablePromise<NotificationOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service_requests/notification/templates/{notification_id}',
            path: {
                'notification_id': notificationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Notification
     * @param notificationId
     * @param requestBody
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static updateNotificationServiceRequestsNotificationTemplatesNotificationIdPut(
        notificationId: number,
        requestBody: NotificationUpdate,
    ): CancelablePromise<NotificationOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/service_requests/notification/templates/{notification_id}',
            path: {
                'notification_id': notificationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Notification
     * @param notificationId
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static deleteNotificationServiceRequestsNotificationTemplatesNotificationIdDelete(
        notificationId: number,
    ): CancelablePromise<NotificationOut> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/service_requests/notification/templates/{notification_id}',
            path: {
                'notification_id': notificationId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Notification By Name
     * @param name
     * @returns NotificationOut Successful Response
     * @throws ApiError
     */
    public static getNotificationByNameServiceRequestsNotificationTemplatesByNameNameGet(
        name: string,
    ): CancelablePromise<NotificationOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/service_requests/notification/templates/by-name/{name}',
            path: {
                'name': name,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
